export { default } from './InformationsModal';
